import { render } from "./PokemonPicture.vue?vue&type=template&id=2702e0df&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=2702e0df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2702e0df"

export default script